import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle2, GraduationCap } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { clearRegistrationSession, getRegistrationSuccess } from '../../utils/registrationSession';

export default function RegisterSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const registration = location.state?.registration || getRegistrationSuccess();

  useEffect(() => {
    if (!registration) {
      navigate('/register', { replace: true });
      return;
    }
    clearRegistrationSession();
  }, [registration, navigate]);

  if (!registration) {
    return null;
  }

  const rows = [
    { label: 'School Name', value: registration.school_name },
    { label: 'School Code', value: registration.school_code },
    { label: 'Registered Email', value: registration.email },
    { label: 'Current Plan', value: registration.plan_name || 'Free' },
  ];

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-600/20 via-transparent to-transparent pointer-events-none" />
      <Card className="w-full max-w-md relative z-10 bg-card/90 backdrop-blur-xl border-border/60 shadow-2xl text-center">
        <CardHeader className="pb-2">
          <div className="mx-auto mb-4 w-16 h-16 bg-green-600 rounded-2xl flex items-center justify-center shadow-lg animate-in zoom-in-95 fade-in duration-500">
            <CheckCircle2 className="w-9 h-9 text-white" />
          </div>
          <CardTitle className="text-2xl font-bold text-foreground">Registration complete!</CardTitle>
          <CardDescription className="text-muted-foreground">
            Your school account has been created. Login credentials have been sent to your email.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg border border-border/60 bg-muted/30 text-left divide-y divide-border/40">
            {rows.map((row) => (
              <div key={row.label} className="flex justify-between gap-4 px-4 py-3 text-sm">
                <span className="text-muted-foreground">{row.label}</span>
                <span className="font-medium text-foreground text-right">{row.value || '—'}</span>
              </div>
            ))}
          </div>

          <Button asChild className="w-full">
            <Link to="/login">
              <GraduationCap className="w-4 h-4 mr-2" />
              Go to Login
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
